import { c as _c } from "react/compiler-runtime";
import { FaroTableBulkActions } from "@components/common/faro-table/faro-table-bulk-actions";
import { SkeletonProjectListItemCard } from "@components/common/mobile/skeleton-project-list-item-card";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { Box } from "@mui-wrapper";
import { useSnapshotMenuOptions } from "@pages/project-details/project-snapshots/hooks/use-snapshot-menu-options";
import { SnapshotListItemCardMobile } from "@pages/project-details/project-snapshots/snapshot-list-item-card-mobile";
import { SnapshotsBeingCreatedIndicator } from "@pages/project-details/project-snapshots/snapshots-being-created-indicator";
import { getOpenSnapshotHref, trackOpenSnapshot } from "@pages/project-details/project-snapshots/snapshot-utils";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { setTableType } from "@store/table/table-slice";
import { TableType } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback, useEffect } from "react";
import { FaroTableEmptyPage } from "@components/common/faro-table/faro-table-empty-page";
/**
 * Mobile-specific view for the snapshots list with card layout and bulk actions footer.
 */
export function SnapshotsMobileView(t0) {
  const $ = _c(27);
  const {
    snapshots,
    isLoading,
    sortBy,
    bulkActionButtons
  } = t0;
  const dispatch = useAppDispatch();
  const {
    trackAsyncEvent
  } = useTrackEvent();
  const menuItems = useSnapshotMenuOptions();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("snapshots");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const projectLaunchSettings = useAppSelector(defaultProjectLaunchTargetSelector);
  const shouldShowEmptyPage = snapshots.length === 0 && !isLoading;
  let t2;
  let t3;
  if ($[1] !== dispatch) {
    t2 = () => {
      dispatch(setTableType(TableType.snapshots));
    };
    t3 = [dispatch];
    $[1] = dispatch;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== projectLaunchSettings.defaultOpenProjectTarget || $[5] !== trackAsyncEvent) {
    t4 = async snapshot => {
      const openTarget = projectLaunchSettings.defaultOpenProjectTarget;
      await trackOpenSnapshot({
        openTarget,
        trackAsyncEvent,
        openFrom: "snapshot-table-row",
        accessLevel: snapshot.accessLevel,
        createdAt: snapshot.createdAt
      });
      const targetHref = getOpenSnapshotHref({
        openTarget,
        snapshotId: snapshot.id
      });
      window.open(targetHref, "_blank", "noopener,noreferrer");
    };
    $[4] = projectLaunchSettings.defaultOpenProjectTarget;
    $[5] = trackAsyncEvent;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSnapshotClick = t4;
  let t5;
  if ($[7] !== snapshots) {
    t5 = snapshots.map(_temp);
    $[7] = snapshots;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const allSnapshotIds = t5;
  if (shouldShowEmptyPage) {
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <FaroTableEmptyPage />;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SnapshotsBeingCreatedIndicator sx={{
      px: 2,
      py: 1
    }} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleSnapshotClick || $[12] !== menuItems) {
    t7 = snapshot_1 => <Box key={snapshot_1.id}><SnapshotListItemCardMobile snapshot={snapshot_1} onCardClick={() => void handleSnapshotClick(snapshot_1)} menuItems={menuItems} /></Box>;
    $[11] = handleSnapshotClick;
    $[12] = menuItems;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isLoading || $[15] !== snapshots || $[16] !== sortBy || $[17] !== t7) {
    t8 = <VirtualizedGrid key={sortBy} items={snapshots} isLoading={isLoading} renderSkeletonItem={_temp2} estimateSize={112} shouldMeasureRowHeight={true} renderItem={t7} />;
    $[14] = isLoading;
    $[15] = snapshots;
    $[16] = sortBy;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== allSnapshotIds || $[20] !== bulkActionButtons || $[21] !== isLoading || $[22] !== selectedEntities.length) {
    t9 = <FaroTableBulkActions bulkActionsButtons={bulkActionButtons} numberOfSelectedRows={selectedEntities.length} isLoading={isLoading} allRowIds={allSnapshotIds} />;
    $[19] = allSnapshotIds;
    $[20] = bulkActionButtons;
    $[21] = isLoading;
    $[22] = selectedEntities.length;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <>{t6}{t8}{t9}</>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp2(index) {
  return <Box key={index}><SkeletonProjectListItemCard /></Box>;
}
function _temp(snapshot_0) {
  return snapshot_0.id;
}